module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/store_images/2@2x_358387484213e1b72134122b2fe49957.png";